/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

function modal(){
  // Get the modal
  var modal = document.getElementById("myModal");

  // Get the button that opens the modal
  var btn = document.getElementById("myBtn");

  // Get the <span> element that closes the modal
  var span = document.getElementsByClassName("close")[0];

  // When the user clicks the button, open the modal 
  btn.onclick = function() {
    modal.style.display = "block";
  }

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }

  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
}

// Insert any custom theme js here...
function filter_products(region){
var product_refs = document.getElementsByClassName("card");

  for (i = 0; i < product_refs.length; i++) {
  
    if (product_refs[i].innerHTML.includes(region) == true) {
    	product_refs[i].style.display = "block";
        //  product_refs[i].setAttribute("style","display: block");
    } else {
        //product_refs[i].style.display = "none !important";
        product_refs[i].setAttribute("style","display: none !important");
        product_refs[i].remove();
        i = i - 1;
    }
  }
}

//Display catalog according to customer location
function show_products() {
  //create regions based on first 2 digits of zip code
  var SF = ["94", "95"];
  var LA = ["90", "91", "92", "93"];
  var FL = ["32", "33", "34"];
  
  $.getJSON('https://api.ipify.org?format=json', function(data){
      ip = data.ip;
	//ip = '99.118.240.245'
      $.getJSON('https://ipapi.co/'+ ip +'/json', function(data){
          zip = data.postal.slice(0,2);

          if (window.location.pathname == "/collections/all") {
              //redirects based on zip code response
              switch (true) {
                case SF.includes(zip):
                	location = 'https://thefruittree.co/collections/all/SF';
                	//show_products("sf");
               	 	break;
                case FL.includes(zip):
                	location = 'https://thefruittree.co/collections/all/FL';
                	//show_products("fl");
                	break;
                default:
                  location = 'https://thefruittree.co/collections/all/SF';
              }
          } else {
              //apply filter based on zip code response
              switch (true) {
                case SF.includes(zip):
                	filter_products("/sf-");
                	break;
                case FL.includes(zip):
                	filter_products("/fl-");
                	break;
                default:
                  	filter_products("/sf-");
              }
          }
      });
  });

}

//window.onload = show_products();



//window.onload = document.getElementById('magicbutton').click()
